import PropTypes from 'prop-types';
import imageShape from './imageShape';

const imageDataShape = {
  data: PropTypes.shape(imageShape),
};

export default imageDataShape;
